const MAP_METHODS_SELECTOR_TRACKING = {
  OPENBANKING: 'yourBank',
  TGSS: 'spanishSocialSecurity',
};
const MAP_METHODS_MODAL_TRACKING = {
  OPENBANKING: 'Openbanking',
  TGSS: 'TGSS',
};

export { MAP_METHODS_MODAL_TRACKING, MAP_METHODS_SELECTOR_TRACKING };
